/**
 * Recursivley search an object for a key/value pair
 */
export function recursiveObjSearch (key, value, obj) {
  let r
  for (let p in obj) {
    if (p === key && value === obj[p]) return obj
    if (typeof obj[p] === 'object') {
      if ((r = recursiveObjSearch(key, value, obj[p])) !== null) {
        return r
      }
    }
  }
  return null
}

/**
 * Coerce an Object to an Array.
 */
export const obj2arr = o => Object.keys(o).map(k => o[k])

/**
* Coerce String -> [Integers]
**/
export const str2digits = s => s.match(/\d/g).map(Number)

export const url_params = url => {
  if (url.indexOf('?') < 0) return false
  return _.split(_.last(_.split(url, '?')), '&')
          .reduce((res, xs) => {
            let [k, v] = xs.split('=')
            return _.set(res, k, v)
          }, {})
}

export const content_parser = obj => { return {} }



// WEBPACK FOOTER //
// ./src/utils/util.js